var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocuspointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    id: "focuspointicon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.5,7.5c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S13.706,7.5,11.5,7.5z M11.5,14.5c-1.654,0-3-1.346-3-3 s1.346-3,3-3s3,1.346,3,3S13.154,14.5,11.5,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.5,11h-2.525C19.724,6.712,16.288,3.276,12,3.026V0.5C12,0.224,11.776,0,11.5,0S11,0.224,11,0.5v2.526 C6.712,3.276,3.276,6.712,3.025,11H0.5C0.224,11,0,11.224,0,11.5S0.224,12,0.5,12h2.525c0.251,4.288,3.687,7.724,7.975,7.975V22.5 c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-2.525c4.288-0.251,7.724-3.687,7.975-7.975H22.5c0.276,0,0.5-0.224,0.5-0.5 S22.776,11,22.5,11z M11.5,19C7.364,19,4,15.636,4,11.5C4,7.365,7.364,4,11.5,4S19,7.365,19,11.5C19,15.636,15.636,19,11.5,19z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "invisible_shape"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocuspointIcon);
export default __webpack_public_path__ + "static/media/focuspoint-icon.698d35f93ae34d4490e2c749a98f89b2.svg";
export { ForwardRef as ReactComponent };